// ---------------------------------------------------------------------------
// SCREENS THAT CANNOT AFFORD THE WHOLE DESIGN.
//
// Universe is read on two kinds of screen. One is a desktop browser on a
// laptop or a workstation, where a masked layer, a blurred layer and a
// never-ending animation are free. The other is a TELEVISION: the Barzanò
// delivery board runs on Amazon Silk on a Fire TV, on a wall, 24 hours a day.
//
// A mask or a `filter` is an offscreen buffer the size of the box it is on,
// and an infinite animation keeps the compositor awake for as long as the page
// is open. A Fire TV renderer has a few hundred megabytes for everything and
// no desktop GPU behind it: the panel on the sign-in page reaches tens of
// megabytes of raster buffers before a pixel of the form is drawn, and the tab
// is killed rather than slowed. From the sofa nobody could have seen the
// difference anyway — a television is read from four metres.
//
// So the expensive half of a decorative surface is gated on this flag: the
// composition stays, the buffers go. It is NOT a mobile check — phones run the
// full design — and it is NOT `prefers-reduced-motion`, which is a statement
// about motion, not about memory (surfaces honour that separately).
//
// Read once per session: neither the user agent nor the core count moves.
// ---------------------------------------------------------------------------

/**
 * Television and set-top browsers. `Silk` covers Amazon's own (Fire TV and
 * Fire tablets), `AFT…` the Fire TV device codes that reach some builds, and
 * the rest are the smart-TV platforms a dashboard ends up on next.
 */
const TV_AGENT =
  /\bSilk\b|\bAFT[A-Z]|SMART-?TV|SmartTV|Tizen|Web0S|WebOS|HbbTV|BRAVIA|VIERA|AQUOS|NetCast|CrKey|GoogleTV|AndroidTV|PlayStation|Xbox/i;

function detect() {
  if (typeof window === 'undefined') return false;
  const nav = window.navigator || {};
  if (TV_AGENT.test(nav.userAgent || '')) return true;
  // Two cores or fewer is a set-top box or a ten-year-old machine; either way
  // not somewhere to spend a dozen composited layers.
  const cores = nav.hardwareConcurrency;
  return typeof cores === 'number' && cores > 0 && cores <= 2;
}

export const LOW_POWER = detect();

export default LOW_POWER;
